import React from 'react';
import OrderSummaryContent from './OrderSummaryContent';

/**
 * Fixed right sidebar for Order Summary (desktop only)
 */
const OrderSummarySidebar = ({
    ordersByDeliveryDate,
    deliveryDates,
    billingChanges,
    customerToken,
    pendingChanges,
    priorPaymentsByDate,
    paymentRecords,
    onSaveSuccess,
    customerDetails,
    deliveryTimeOverrides,
    onDeliveryTimeChange,
    onClose
}) => {
    return (
        <aside className="order-sidebar" style={{ zIndex: 120 }}>
            {onClose && (
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close order summary"
                    style={{
                        position: 'sticky', top: 0, marginLeft: 'auto', display: 'block',
                        background: '#fff', border: '1px solid #e0d9cb', borderRadius: '50%',
                        width: '34px', height: '34px', fontSize: '18px', lineHeight: 1,
                        color: '#333', cursor: 'pointer', zIndex: 5,
                    }}
                >
                    ×
                </button>
            )}
            <OrderSummaryContent
                ordersByDeliveryDate={ordersByDeliveryDate}
                deliveryDates={deliveryDates}
                billingChanges={billingChanges}
                customerToken={customerToken}
                customerName={customerDetails?.customer?.name || ''}
                pendingChanges={pendingChanges}
                priorPaymentsByDate={priorPaymentsByDate}
                paymentRecords={paymentRecords}
                onSaveSuccess={onSaveSuccess}
                variant="sidebar"
                customerDetails={customerDetails}
                deliveryTimeOverrides={deliveryTimeOverrides}
                onDeliveryTimeChange={onDeliveryTimeChange}
            />
        </aside>
    );
};

export default OrderSummarySidebar;
